module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Sound_Bar.52291cbc.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Sound_Bar.svg
// module id = 3546
// module chunks = 0